import React from 'react';
import { motion } from 'framer-motion';
import { Check, Heart } from 'lucide-react';
export function Method() {
  const benefits = ['Cómo sanar tus resentimientos ocultos.', 'Cómo reconstruir la conexión emocional paso a paso.', 'Cómo hablar desde el corazón sin provocar discusiones.', 'Cómo despertar de nuevo la admiración y el deseo.', 'Cómo recuperar la complicidad que los unió.'];
  return <section className="py-8 md:py-12 bg-[#faf8f6]" data-id="element-173">
      <div className="max-w-5xl mx-auto px-6" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-12" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-serif text-[#2d2d2d] mb-8" data-id="element-176">
            ¿Qué es realmente el divorcio emocional?
          </h2>
          <div className="prose prose-lg mx-auto text-[#5a5a5a]" data-id="element-177">
            <p className="mb-4" data-id="element-178">
              No es la ruptura del matrimonio. No es separación. No es
              renunciar.
            </p>
            <p className="mb-8 font-medium text-[#9d4b6b]" data-id="element-179">
              Es la desconexión silenciosa que va apagando lo que un día unió
              sus almas.
            </p>
            <p className="mb-4" data-id="element-180">
              No te diste cuenta cuándo empezó. Un día dejaron de hablar con
              profundidad. Luego dejaron de mirarse a los ojos. Luego dejaron de
              tocarse. Y lo siguiente que perdiste fue la esperanza.
            </p>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-[#d4a5a5]/20 my-8" data-id="element-181">
              <p className="text-xl font-serif italic text-[#2d2d2d]" data-id="element-182">
                Pero aquí está la verdad que nadie te dice: El amor no muere. El
                amor se desconecta. Y lo que se desconecta… se puede reconectar.
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mt-16" data-id="element-183">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-184">
            <div className="absolute -top-10 -left-10 w-20 h-20 bg-[#d4a5a5]/20 rounded-full blur-xl" data-id="element-185"></div>
            <h2 className="text-4xl md:text-5xl font-serif text-[#2d2d2d] mb-4 leading-tight" data-id="element-186">
              TE PRESENTO: <br data-id="element-187" />
              <span className="text-[#9d4b6b]" data-id="element-188">EL DIVORCIO EMOCIONAL</span>
            </h2>
            <p className="text-xl text-[#5a5a5a] mb-8" data-id="element-189">
              Este devuelve la conexión, la pasión y la armonía al corazón de tu matrimonio
            </p>
            <p className="text-[#5a5a5a] mb-6 leading-relaxed" data-id="element-190">
              Este no es un libro común. No es teoría. No es filosofía
              romántica.
            </p>
            <p className="text-[#5a5a5a] mb-8 leading-relaxed font-medium" data-id="element-191">
              Es un método práctico creado especialmente para ti: una mujer
              latina, amorosa, espiritual, dedicada y cansada de sufrir en
              silencio.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl shadow-[#9d4b6b]/5 border border-[#d4a5a5]/20" data-id="element-192">
            <h3 className="text-xl font-serif text-[#2d2d2d] mb-6 flex items-center gap-2" data-id="element-193">
              <Heart className="w-5 h-5 text-[#9d4b6b] fill-current" data-id="element-194" />
              Lo que aprenderás:
            </h3>
            <ul className="space-y-4" data-id="element-195">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3 text-[#5a5a5a]" data-id="element-196">
                  <div className="mt-1 min-w-[20px]" data-id="element-197">
                    <Check className="w-5 h-5 text-[#9d4b6b]" data-id="element-198" />
                  </div>
                  <span data-id="element-199">{benefit}</span>
                </motion.li>)}
            </ul>

            <div className="mt-8 pt-8 border-t border-gray-100" data-id="element-200">
              <p className="text-[#9d4b6b] font-medium text-center italic" data-id="element-201">
                Y lo más importante: Sin terapia. Sin exponer tus problemas a
                nadie. Sin pedirle a él que cambie primero.
              </p>
              <p className="text-[#5a5a5a] text-sm text-center mt-4" data-id="element-202">
                Comienza contigo. Con tu claridad. Con tu inteligencia
                emocional. Con tu poder interior.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}